<template>
  	<AddPinBatch />
</template>

<script>

// @ is an alias to /src
import AddPinBatch from "@/components/SubscriptionBaseSales/subscriptionBatch/AddSubscriptionCodeBatch.vue";

export default {
  name: "SubscriptionCodeBatch",
  components: {
    AddPinBatch,
  },
};
</script>
